import { Context } from '../..';
import { DepartmentSearchResponse } from '../../../models/view/department-search-response';
import { Department } from '../../../models/view/department';
import { BaseSearchRequest } from '../../../models/overmind/search-request';
import * as base from '../base';
import { SortField } from '../../../enums/sort-field';
import { NotificationPriority, NotificationType } from '../../../notifications/notifications.models';
import { Entity } from '../../../models';
import { RequiredEntity } from '../../../models/view/entity';

export async function getDepartmentKeyValues(): Promise<RequiredEntity[] | undefined> {
  const request: base.IRequest = { url: base.apiURL(`department`, `get-department-key-values`), authenticated: true };
  const response: base.IResponse<RequiredEntity[]> = await base.request(request);
  return response.data;
}

export async function getDepartmentKeyValuesByCompany(_: Context, companySlug: string): Promise<RequiredEntity[] | undefined> {
  const request: base.IRequest = { url: base.apiURL(`department`, `get-department-key-values`, companySlug), authenticated: true };
  const response: base.IResponse<RequiredEntity[]> = await base.request(request);
  return response.data;
}

export async function getDepartments(context: Context, companySlug: string): Promise<Department[] | undefined> {
  const request: base.IRequest = { url: base.apiURL(`department`, `get-departments`, companySlug), authenticated: true };
  const response: base.IResponse<Department[]> = await base.request(request);

  return response.data;
}

export const searchDepartments = async (context: Context, SearchRequest: BaseSearchRequest): Promise<DepartmentSearchResponse | undefined> => {
  const request: base.IRequest = { url: base.apiURL(`department`, `search-departments`, `${context.state.companyVariables.slug}${base.params(SearchRequest)}`) };
  const response: base.IResponse<DepartmentSearchResponse> = await base.request(request);
  return response.data;
};

export async function getAllDepartments(context: Context, companySlug: string) {
  const request: BaseSearchRequest = {
    companySlug,
    sortField: SortField.Name,
    sortAscending: true,
    page: 1,
    pageSize: 1000,
  };

  return await searchDepartments(context, request);
}

export async function saveDepartment(context: Context, payload: { department: Entity; companySlug: string }): Promise<Department | undefined> {
  const request: base.IRequest = { url: base.apiURL(`department`, `save-department`, payload.companySlug), authenticated: true, method: 'POST', body: JSON.stringify(payload.department) };
  const response: base.IResponse<Department> = await base.request(request);

  return response.data;
}

export const getDepartment = async (context: Context, data: { departmentSlug: string; companySlug: string }): Promise<Department | undefined> => {
  const request: base.IRequest = { url: base.apiURL(`department`, `get-department`, data.companySlug, data.departmentSlug), authenticated: true };
  const response: base.IResponse<Department> = await base.request(request);

  return response.data;
};

export const archiveDepartment = async (context: Context, departmentSlug: string) => {
  const url = base.apiURL(`department`, `archive`, departmentSlug);
  const request: base.IRequest = { url: url, authenticated: true, method: 'PUT' };
  const response: base.IResponse<Department> = await base.request(request);

  if (!!response.error) {
    context.actions.addNotification({
      id: departmentSlug,
      type: NotificationType.Error,
      priority: NotificationPriority.Toast,
      title: '',
      message: `Cannot archive department. Please contact support`,
      active: true,
    });
  } else
    context.actions.addNotification({
      id: departmentSlug,
      type: NotificationType.Success,
      priority: NotificationPriority.Toast,
      title: '',
      message: `Department archived successfully`,
      active: true,
    });
};
